export default __webpack_public_path__ + "static/media/sd-masks.07e6fb10.png";